var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112.399,
    height: 128,
    viewBox: "0 0 112.399 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13119",
    "data-name": "Group 13119",
    transform: "translate(-6195.028 -905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6534",
    "data-name": "Path 6534",
    d: "M439.187,163.655V94.3a4.7,4.7,0,0,0-9.4,0v69.356a16.8,16.8,0,0,0-12.029,16.164A16.578,16.578,0,0,0,429.789,195.8v17.1a4.7,4.7,0,0,0,9.4,0V195.8a16.75,16.75,0,0,0,0-32.143Zm-4.7,23.307a7.33,7.33,0,1,1,7.33-7.33A7.339,7.339,0,0,1,434.488,186.962Z",
    transform: "translate(5856.211 815.401)",
    fill: "#ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6535",
    "data-name": "Path 6535",
    d: "M327.187,107.267V94.3a4.7,4.7,0,1,0-9.4,0v12.969a16.8,16.8,0,0,0-12.029,16.164,16.578,16.578,0,0,0,12.029,15.977V212.9a4.7,4.7,0,1,0,9.4,0V139.409a16.749,16.749,0,0,0,0-32.141Zm-4.7,23.307a7.33,7.33,0,1,1,7.33-7.33A7.339,7.339,0,0,1,322.488,130.574Z",
    transform: "translate(5930.619 815.401)",
    fill: "#ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6536",
    "data-name": "Path 6536",
    d: "M203.987,141.1V94.3a4.7,4.7,0,1,0-9.4,0v46.8a16.8,16.8,0,0,0-12.029,16.164,16.578,16.578,0,0,0,12.029,15.977V212.9a4.7,4.7,0,1,0,9.4,0V173.241a16.749,16.749,0,0,0,0-32.141Zm-4.7,23.307a7.33,7.33,0,1,1,7.33-7.33A7.339,7.339,0,0,1,199.288,164.407Z",
    transform: "translate(6012.468 815.401)",
    fill: "#ffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.627f0ff08bf1c1c63c3591ad3d200b6d.svg";
export { ForwardRef as ReactComponent };